import React from "react";
import Agent from "./agent.jsx";
export const getAllCustomer = async (barbershop) => {
  // Your API call to authenticate the user
  // If successful, save the token to localStorage
  const { requests } = Agent();
  const token = localStorage.getItem("authToken");
  return await requests.get(
    `/Customer/customerlabels/${barbershop}`,
    token,
    barbershop
  );
};
export const getCustomerList = async (barbershop) => {
  // Your API call to authenticate the user
  // If successful, save the token to localStorage
  const { requests } = Agent();
  const token = localStorage.getItem("authToken");
  return await requests.get(`/Customer/all/${barbershop}`, token, barbershop);
};
export const addCustomer = async (customer, shopId) => {
  const token = localStorage.getItem("authToken");
  try {
    const params = {
      ShopId: shopId,
      FirstName: customer.firstName,
      LastName: customer.lastName,
      PhoneNumber: customer.phoneNumber,
      Email: customer.email,
    };
    const { requests } = Agent();
    return await requests.post(`/Customer/`, params, token, shopId);
  } catch (error) {
    console.error(
      "Error updating barber unavailability:",
      error.response?.data || error.message
    );
    throw error;
  }
};
export const updateCustomer = async (customer, shopId) => {
  try {
    const params = {
      Id: customer.id,
      ShopId: shopId,
      FirstName: customer.firstName,
      LastName: customer.lastName,
      PhoneNumber: customer.phoneNumber,
      Email: customer.email,
    };
    const token = localStorage.getItem("authToken");
    const { requests } = Agent();

    return await requests.put(`/Customer/`, params, token, shopId);
  } catch (error) {
    console.error(
      "Error updating barber",
      error.response?.data || error.message
    );
    throw error;
  }
};
